module.exports = __webpack_public_path__ + "img/logo@2x.ebb52e22.png";